(function ($) {
  function videoOverlay() {
    $(document).on("click", ".enlarge", function (e) {
      e.preventDefault();
      var img = $(this).parent().find(".img-wrap").clone();
      $(".img-video-overlay").find(".img-video-container").html(img);
      $(".img-video-overlay").addClass("overlay-active");
    });
    closeVideoOverlay();
  }

  // Close video overlay on outside/close-btn click
  function closeVideoOverlay() {
    // Close video overlay on close button & outside click
    $(document).on("click", ".img-video-overlay", function () {
      $(".img-video-overlay").find("iframe").attr("src", "");
      $(".img-video-overlay").removeClass("overlay-active");
    });
    // Prevent closing on video's click
    $(".img-video-overlay  iframe").on("click", function (e) {
      e.stopPropagation();
    });
  }

  $(document).ready(function () {
    videoOverlay();
    video_height();

  });
  $(window).on("load scroll resize", function () {
    video_height();
  });

  function video_height() {
    var windowheight = $(window).height() / 1.9,
      windowWidth = $(window).width() / 1.2;
    $(".img-video-overlay iframe").attr("width", windowWidth + "px");
    $(".img-video-overlay iframe").attr("height", windowheight + "px");
  }
})(jQuery);
